export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * i)
    const temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

// flatten array of arrays into single array consisting of all the items in each array
export const mergeArrays = arrays => [].concat.apply([], arrays)

export const isNonEmptyArray = arr => Array.isArray(arr) && arr.length > 0
